import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=42aaa98b&scoped=true&"
import script from "./notes.vue?vue&type=script&lang=js&"
export * from "./notes.vue?vue&type=script&lang=js&"
import style0 from "./notes.vue?vue&type=style&index=0&id=42aaa98b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aaa98b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42aaa98b')) {
      api.createRecord('42aaa98b', component.options)
    } else {
      api.reload('42aaa98b', component.options)
    }
    module.hot.accept("./notes.vue?vue&type=template&id=42aaa98b&scoped=true&", function () {
      api.rerender('42aaa98b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/notes/notes.vue"
export default component.exports